// eslint-disable-next-line no-unused-vars
import React from 'react';
import InstallerResource from '../resource/resource';
import BaseUrl from '../base-url/base-url';
import Link from '@jetbrains/ring-ui/components/link/link';
import i18n from '../i18n/i18n';
import alertService from '@jetbrains/ring-ui/components/alert-service/alert-service';


export default angular.module('installer.start-installation', [InstallerResource.name, BaseUrl.name, i18n.name]).
  factory('startInstallation', ($q, $location, installerResource, fields, baseUrlValidator, alertMessageWithLink, wizardInfo) => {

    function removeContext(url, context) {
      const contextIndex = url.lastIndexOf(context);
      if (context !== '/' && contextIndex > 0) {
        return url.substring(0, contextIndex);
      }
      return url;
    }

    function makeErrorMessage(listenAddress, listenPort) {
      /* jshint ignore:start */
      return (
        <div>
          <p>{wizardInfo.productName} is not accessible from the Base URL that was specified in the Configuration
            Wizard.
          </p>
          <p>
            Your {wizardInfo.productName} service is starting. It will listen on the following address and port when
            ready: <b>{listenAddress}:{listenPort}</b>
          </p>

          <div>To check the status of the service, enter the following command on the server: </div>
          <div>[{wizardInfo.productScriptPath} status]</div>
        </div>
      );
      /* jshint ignore:end */
    }

    function makeUncheckedNewCertificateErrorMessage(listenAddress, listenPort, productUrl) {
      /* jshint ignore:start */
      return (
        <div>
          <p>
            The configuration has been saved and {wizardInfo.productName} is starting. It will listen on the following address and port when
            ready: <b>{listenAddress}:{listenPort}</b>
          </p>
          <p>
            Because the TLS certificate for your server was updated, startup progress is not available from this page.
          </p>
          <p>If you wait a few minutes, you can try to access the startup status for the service from the following address: <b/>
            <a href={productUrl}>{productUrl}</a> <br/>
          </p>

          <div>Alternatively, you can check the status of the service by executing the following command on the server: </div>
          <div>[{wizardInfo.productScriptPath} status]</div>
        </div>
      );
      /* jshint ignore:end */
    }

    function makeUntrustedCertificateMessage(listenAddress, listenPort, productUrl) {
    /* jshint ignore:start */
      return (
        <div>
          <p>
        The configuration has been saved and {wizardInfo.productName} is starting.
          </p>
          <p>
        Because the TLS certificate for your server is not trusted by your web browser, startup progress is not available from this page.
          </p>
          <p>If you wait a few minutes, you can try to access the startup status for the service from the following address: <b/>
            <a href={productUrl}>{productUrl}</a> <br/>
          </p>

          <div>Alternatively, you can check the status of the service by executing the following command on the server: </div>
          <div>[{wizardInfo.productScriptPath} status]</div>
        </div>
      );
    /* jshint ignore:end */
    }

    return function startInstallation() {
      let urlAfterCompletion;
      let spareUrlAfterCompletion;
      let spareUrlAfterCompletionWithoutContext;
      let listenAddressAfterCompletion;
      let listenPortAfterCompletion;
      let baseUrlBackendAccessState;
      let testEndpointState;

      function dumpWizard() {
        return installerResource.dump.save().$promise;
      }

      return installerResource.urlAfterCompletion.get().$promise.then(result => {
        urlAfterCompletion = result[fields.URL_TO_SHOW_AFTER_COMPLETION];

        spareUrlAfterCompletion = result[fields.URL_SPARE_TO_SHOW_AFTER_COMPLETION];
        spareUrlAfterCompletionWithoutContext = removeContext(spareUrlAfterCompletion, result[fields.URL_AFTER_COMPLETION_CONTEXT]);

        listenAddressAfterCompletion = result[fields.LISTEN_ADDRESS_AFTER_COMPLETION];
        listenPortAfterCompletion = result[fields.LISTEN_PORT_AFTER_COMPLETION];
        baseUrlBackendAccessState = result[fields.BASE_URL_BACKEND_ACCESS_STATE];
        testEndpointState = result[fields.TEST_ENDPOINT_STATE];

        return result[fields.IS_BUNDLE_ACCESSIBLE];
      }).
        then(isBundleAccessible => {
          function dumpAndReturnWithError() {
            return dumpWizard().then(() => {
              let errorMessage;
              if (testEndpointState === 'impossibleToCheckNewServerCertWarning' && urlAfterCompletion.indexOf('https://') === 0) {
                errorMessage = makeUncheckedNewCertificateErrorMessage(listenAddressAfterCompletion, listenPortAfterCompletion, urlAfterCompletion);
              } else if (baseUrlBackendAccessState === 'untrustedCertificate') {
                errorMessage = makeUntrustedCertificateMessage(listenAddressAfterCompletion, listenPortAfterCompletion, urlAfterCompletion);
              } else {
                errorMessage = makeErrorMessage(listenAddressAfterCompletion, listenPortAfterCompletion);
              }
              return $q.reject(errorMessage);
            });
          }
          if (!isBundleAccessible) {
            if (spareUrlAfterCompletion.indexOf('https://') === 0) {
              return dumpAndReturnWithError();
            } else {
              return baseUrlValidator.validateNonSecureUrl(spareUrlAfterCompletionWithoutContext, listenAddressAfterCompletion, listenPortAfterCompletion).
                then(() => {
                  urlAfterCompletion = spareUrlAfterCompletion;
                }).catch(() => dumpAndReturnWithError());
            }
          }
        }).
        then(dumpWizard).
        catch(err => {
          if (err.status === -1) {
            alertService.error(alertMessageWithLink('The connection to the Configuration Wizard was lost. Don\'t worry, your upgrade is probably complete.', 'Check the installation', urlAfterCompletion));
          }
          return $q.reject(err);
        }).
        then(function redirectToWait() {
          $location.url(`wait?url=${urlAfterCompletion}`);
        });
    };
  }).
  factory('alertMessageWithLink', () => function factory(message, linkText, href) {
    const link = Link.factory({
      key: linkText,
      href,
      target: '_blank',
      className: 'ring-link'
    }, linkText);

    return [message, ' ', link];
  });



// WEBPACK FOOTER //
// ./src/blocks/start-installation/start-installation.js